/**
 * 第三方像素上报
 */
import { useCmsDataStore } from "~/stores/cms-data";
import {
	initGooglePixel,
	resultGooglePixelCode,
	googleOtherEvent,
} from "~/utils/googlePixel";
import { initFbPixel, resultFbPixelCode } from "~/utils/facebookPixel";

const usePixel = () => {
	// 像素初始化
	const initPixel = async () => {
    // 只在客户端执行
    if (!import.meta.client) return;

    try {
      const store = useCmsDataStore();
      const google_pixel_code = store.cmsConfig.google_pixel_code;
      const fb_px_code_id = store.cmsConfig.fb_px_code_id;

      initGooglePixel(google_pixel_code); //谷歌初始化
      initFbPixel(fb_px_code_id); //facebook初始化
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * 购买事件上报
   * @param orderId 订单号
   * @param amount 金额
   * @param prop_currency 货币类型,默认USD
   * */
  const reportPurchase = async (orderId, amount, prop_currency) => {
    // 只在客户端执行
    if (!import.meta.client) return;

    try {
      const store = useCmsDataStore();
      const google_pixel_code = store.cmsConfig.google_pixel_code;

      resultGooglePixelCode(google_pixel_code, orderId, amount, prop_currency); //谷歌付费回传
      resultFbPixelCode(amount, orderId, prop_currency); //fb付费回传
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * 谷歌 - 其他事件上报，传事件名（与配置中心字段名一致）
   * */
  const reportGooglePixelEvent = async (evenName) => {
    // 只在客户端执行
    if (!import.meta.client) return;

    try {
      const store = useCmsDataStore();
      const google_pixel_code = store.cmsConfig.google_pixel_code;

      googleOtherEvent(google_pixel_code, evenName); //谷歌其他事件
    } catch (error) {
      console.error(error);
    }
  };

	return {
		initPixel,
		reportPurchase,
		reportGooglePixelEvent,
	};
};

export default usePixel;
